import type { ReactNode } from 'react'
import { Modal } from '../modal'
import { AcknowledgeModal } from '../acknowledge-modal'
import { ActionModal } from '@percent/lemonade'
import type { ConfirmationResultModalProps } from './confirmation-result-modal.types'

export const ConfirmationResultModal = ({
  success,
  failure,
  title,
  primaryButtonText,
  secondaryButtonText,
  state,
  loading,
  loadingText,
  disabled,
  children,
  isOpen,
  onConfirm,
  onClose,
  onFailureClose,
  primaryBtnTestId,
  secondaryBtnTestId,
  buttonTestId,
}: ConfirmationResultModalProps) => {
  const handleFailureClose = onFailureClose ?? onClose

  return (
    <Modal
      open={isOpen}
      onClose={state === 'failure' ? handleFailureClose : onClose}
    >
      {state === 'success' ? (
        <AcknowledgeModal
          result="positive"
          title={success.title}
          description={success.description}
          buttonText={success.button}
          buttonTestId={buttonTestId}
          handleClose={onClose}
        />
      ) : state === 'failure' ? (
        <AcknowledgeModal
          result="negative"
          title={failure.title}
          description={failure.description}
          buttonText={failure.button}
          buttonTestId={buttonTestId}
          handleClose={handleFailureClose}
        />
      ) : (
        <ActionModal
          title={title}
          primaryButtonText={primaryButtonText}
          secondaryButtonText={secondaryButtonText}
          handleSubmit={onConfirm}
          handleClose={onClose}
          loading={loading}
          loadingText={loadingText}
          disabled={disabled}
          primaryBtnTestId={primaryBtnTestId}
          secondaryBtnTestId={secondaryBtnTestId}
        >
          {children}
        </ActionModal>
      )}
    </Modal>
  )
}
